import React from 'react';
import type {BoxProps} from '@tempo/core';
import {Heading, Text, VStack} from '@tempo/core';
import HeaderRow from '@components/PageElements/PageHeader/HeaderRow';
import Breadcrumb from '@components/PageElements/PageHeader/Breadcrumb';

type TitleRowProps = {
	title?: string;
	subtitle?: React.ReactNode;
	rightElements?: React.ReactNode;
	breadcrumbs?: {key: string; label: string; url: string}[];
	childrenContainerProps?: BoxProps;
};

const TitleRow = ({
	title,
	subtitle,
	breadcrumbs,
	rightElements,
	childrenContainerProps,
	...props
}: TitleRowProps) => {
	return (
		<HeaderRow
			border="bottom"
			leftElements={
				<>
					{breadcrumbs &&
						breadcrumbs.map(b => (
							<Breadcrumb key={b.key} label={b.label} url={b.url} />
						))}
					<VStack
						alignItems="initial"
						justifyContent="center"
						spacing="spacing.xs"
						minHeight="size.m"
						{...props}
					>
						{title && (
							<Heading as="h1" variant={'heading.xs'}>
								{title}
							</Heading>
						)}
						{subtitle && (
							<Text
								color="text.neutral.secondary.default"
								variant="caption.strong"
							>
								{subtitle}
							</Text>
						)}
					</VStack>
				</>
			}
			rightElements={rightElements}
		/>
	);
};

export default TitleRow;
